// extracted by mini-css-extract-plugin
export var messageSideLeft = "_o4-1";
export var messageSideRight = "_o4-2";
export var subscribeToBackInStockBubbleContainer = "_o4-0";